// @ts-check
import HTTP from '@/utils/http';

/**
 * @param {string} nameSpace
 * @param {object} options
 * @param {string} [options.endpoint]
 * @param {string} [options.method]
 * @param {object} [options.data]
 * @param {object} [options.params]
 * @param {string} [options.responseType]
 */
export default function useRequest(nameSpace, options = {}) {
  const optionsWithDefaults = {
    endpoint: '',
    method: 'POST',
    data: {},
    params: {},
    responseType: 'json',
    ...options,
  };

  /**
   * @param {string} fingerprint
   * @param {object} [params]
   * @param {object} [data]
   */
  async function fetch(fingerprint, params = {}, data = {}) {
    // make the request
    const response = await HTTP({
      url: `${nameSpace}/${fingerprint}/${optionsWithDefaults.endpoint}`,
      method: optionsWithDefaults.method,
      data: { ...optionsWithDefaults.data, ...data },
      params: { ...optionsWithDefaults.params, ...params },
      responseType: optionsWithDefaults.responseType,
    });

    // results!!!
    return response.data;
  }
  return fetch;
}
